import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useSearch from '../hooks/useSearch.js';
// import useUserPermissions from '../hooks/useUserPermissions';
import koneLogo from '../assets/kone-logo.png';
import resolveGuruMain from '../assets/resolveGurumain.jpg';

function Header({ signOut, user }) {
  const navigate = useNavigate();
  const location = useLocation();
  // const { getUserRole } = useUserPermissions();
  const isRunbookPage =
    location.pathname.includes("runbook_list") ||
    location.pathname.includes("view_runbook") ||
    location.pathname.includes("runbook") ||
    location.pathname.includes("edit_runbook");

  const isModulePage =
    location.pathname.includes("module_list") ||
    location.pathname.includes("view_module") ||
    location.pathname.includes("create_module") ||
    location.pathname.includes("edit_module");

  const searchType = isRunbookPage
    ? "runbook"
    : isModulePage
    ? "module"
    : "runbook";
  const {
    searchTerm,
    suggestions,
    searchInputRef,
    searchSuggestionsRef,
    handleSearchChange,
    handleSuggestionClick,
  } = useSearch(navigate, searchType);


  return (
    <>
      <header className="d-flex justify-content-between align-items-center text-white p-3 position-relative">
        <div className="d-flex align-items-center">
          <a href="/runbook_list" className="logo me-3">
            <img src={koneLogo} alt="Org Logo" height="70" />
          </a>
        </div>
        <div className="navigation-bar d-flex align-items-center">
          <button
            id="incidentid"
            onClick={() => navigate("/incident_view")}
            className="nav-button"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            Incident
          </button>
          <button
            id="Runbook"
            onClick={() => navigate("/runbook_list")}
            className="nav-button"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            Runbook
          </button>
          <button
            id="editRunbook"
            onClick={() => navigate("/module_list")}
            className="nav-button"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            Module
          </button>
          <button
            id="classification"
            onClick={() => navigate("/classification")}
            className="nav-button"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            Classification
          </button>
          <button
            id="aiRunbookGenerator"
            onClick={() => navigate("/ai-runbook-generator")}
            className="nav-button"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            AI Runbook
          </button>
        </div>

        {/* Search */}
        {searchType && (
          <div className="search-container ms-auto">
            <input
              type="text"
              className="search-box"
              placeholder={`Search ${searchType}...`}
              value={searchTerm}
              onChange={handleSearchChange}
              ref={searchInputRef}
            />
            {suggestions.length > 0 ? (
              <div className="suggestions" ref={searchSuggestionsRef}>
                {suggestions.map((item, index) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(item)}
                  >
                    {searchType === "runbook"
                      ? item["Runbook Title"]
                      : item["Module Description"]}
                  </div>
                ))}
              </div>
            ) : searchTerm.trim().length > 2 ? (
              <div className="suggestions">No results found</div>
            ) : null}
          </div>
        )}

        <div className="user-info">
          <div className="text-white text-end">
            <div>Welcome, {user?.username || user?.attributes?.name || 'User'}</div>
            {/* <small className="text-light">Role: {getUserRole()}</small> */}
          </div>
          <button 
            onClick={signOut} 
            className="nav-button ms-2"
            style={{
              "--button-selected-color": "#007BFF",
              "--button-selected-border-color": "#007BFF",
            }}
          >
            Logout
          </button>
        </div>
      </header>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
        <img src={resolveGuruMain} alt="ResolveGuru Logo" className="center" style={{ height: '100px', width: '280px' }} />
      </div>
    </>
  );
}

export default Header;
